import React from "react";
import { Hero, NavBar } from "../components";

const Header = ({sub = false}) => {

  const pathName = window.location.pathname;

  return (
    <>
      <NavBar sub={sub} />
      { pathName === '/' && <Hero /> }
    </>
  );
};

export default Header;
